// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";


const firebaseConfig = {
  apiKey: "AIzaSyBlxqaWY6PCRsr1CyXAutmAr33-9mqVn4E",
  authDomain: "client-glfunnel.firebaseapp.com",
  projectId: "client-glfunnel",
  storageBucket: "client-glfunnel.firebasestorage.app",
  messagingSenderId: "144135692330",
  appId: "1:144135692330:web:3ebcd21da7c4e2f1f22353",
  measurementId: "G-NRQTSRCKHP"
};


const app = initializeApp(firebaseConfig);

export default app; // export the app
